import { render, staticRenderFns } from "./studentform.vue?vue&type=template&id=01a8d2a4&scoped=true"
import script from "./studentform.vue?vue&type=script&lang=js"
export * from "./studentform.vue?vue&type=script&lang=js"
import style0 from "./studentform.vue?vue&type=style&index=0&id=01a8d2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8d2a4",
  null
  
)

export default component.exports